<template>
  <div>
    <section class="pt-4 mb-4">
      <div class="container text-center">
        <div class="row">
          <div class="col-lg-6 text-center text-lg-left">
            <h1 class="fw-600 h4">{{ $t("注册您的商店") }}</h1>
          </div>
          <div class="col-lg-6">
            <ul
                class="breadcrumb bg-transparent p-0 justify-content-center justify-content-lg-end"
            >
              <li class="breadcrumb-item opacity-50">
                <router-link class="text-reset" to="/"
                >{{ $t("首页") }}
                </router-link>
              </li>
              <li class="text-dark fw-600 breadcrumb-item">
                <a class="text-reset" href="javascript:void(0);">{{
                    $t("注册您的商店")
                  }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="pt-4 mb-4">
      <div class="container">
        <div class="row">
          <div class="col-xxl-5 col-xl-6 col-md-8 mx-auto ">
            <van-form
                id="shop"
                class=""
                enctype="multipart/form-data"
                method="POST"
                @submit="commit"
            >
              <zfield
                  name="_token"
                  required
                  type="hidden"
                  value="hOl57Oclg456V8DJZEuu3PtAxZMAtl3l0NwjNOnT"
              />
              <div class="bg-white rounded shadow-sm mb-3">
                <div class="fs-15 fw-600 p-3 border-bottom">
                  {{ $t("个人信息") }}
                </div>
                <div class="p-3">
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',codeNumber,')"
                      class="form-group">
                    <label>{{ $t("推广码") }} </label>
                    <van-field
                        v-if="disableCode"
                        v-model="registerForm.codeNumber"
                        class="form-control"
                        disabled
                        name="codeNumber"
                        :placeholder="$t('推广码')"
                        required
                        type="text"
                    />
                    <van-field
                        v-else
                        v-model="registerForm.codeNumber"
                        :rules="[
                        {
                          required: true,
                          message: $t(`请输入`)
                        }
                      ]"
                        class="form-control"
                        name="codeNumber"
                        :placeholder="$t('推广码')"
                        required
                        type="text"
                    />
                  </div>
                  <div class="form-group"
                       v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',realName,')"
                  >
                    <label>{{ $t("你的名字") }} </label>
                    <zfield
                        v-model="registerForm.realName"
                        class="form-control"
                        name="name"
                        :placeholder="$t('你的名字')"
                        required
                        type="text"
                    />
                  </div>
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',username,')"
                      class="form-group">
                    <label>{{ $t("您的用户名") }} </label>
                    <zfield
                        v-model="registerForm.username"
                        class="form-control"
                        name="name"
                        :placeholder="$t('您的用户名')"
                        required
                        type="text"
                    />
                  </div>
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',phone,')"
                      class="form-group"
                  >
                    <label>{{ $t("你的手机号") }}</label>
                    <zfield
                        v-model="registerForm.phone"
                        :placeholder="$t('你的手机号')"
                        class="form-control"
                        name="phone"
                        required
                        type="text"
                    />
                  </div>
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',email,')"
                      class="form-group"
                  >
                    <label>{{ $t("你的邮箱") }}</label>
                    <zfield
                        v-model="registerForm.email"
                        :placeholder="$t('你的邮箱')"
                        class="form-control"
                        name="email"
                        required
                        type="email"
                    />
                  </div>
                  <div class="form-group"
                       v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',smsCode,')"
                  >
                    <label>{{ $t("验证码") }} </label>
                    <valid-code
                        :sendType="'REGISTER_CODE'"
                        required
                        class="form-control"
                        v-model="registerForm.smsCode"
                        :placeholder="$t('验证码')"
                        :phone="registerForm.phone"
                        :email="registerForm.email"
                        :params="registerForm"
                    ></valid-code>
                  </div>
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',password,')"
                      class="form-group">
                    <label>{{ $t("你的密码") }}</label>
                    <zfield
                        v-model="registerForm.password"
                        :placeholder="$t('你的密码')"
                        class="form-control"
                        name="password"
                        required
                        type="password"
                    />
                  </div>
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',rePassword,')"
                      class="form-group">
                    <label>{{ $t("重复输入密码") }} </label>
                    <zfield
                        v-model="registerForm.rePassword"
                        :placeholder="$t('重复输入密码')"
                        class="form-control"
                        name="password_confirmation"
                        required
                        type="password"
                    />
                  </div>
                </div>
              </div>
              <div class="bg-white rounded shadow-sm mb-4">
                <div class="fs-15 fw-600 p-3 border-bottom">
                  {{ $t("基本信息") }}
                </div>
                <div class="p-3">
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',name,')"
                      class="form-group">
                    <label>{{ $t("店铺名称") }} </label>
                    <zfield
                        v-model="registerForm.name"
                        :placeholder="$t('店铺名称')"
                        class="form-control"
                        name="name"
                        required
                        type="text"
                    />
                  </div>
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',contact,')"
                      class="form-group"
                  >
                    <label>{{ $t("地址") }}</label>
                    <zfield
                        v-model="registerForm.contact"
                        :placeholder="$t('地址')"
                        class="form-control mb-3"
                        name="address"
                        required
                        type="text"
                    />
                  </div>

                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',idType,')"
                      class="form-group"
                  >
                    <label>{{ $t('证书类型') }}</label>
                    <div class="dropdown bootstrap-select form-control aiz-">
                      <zselect required v-model="registerForm.idType" classname="EnumUserIdType"
                               :filterFun="(d)=>`,${paramMapAll['REGISTER_PROPS_USER_ID_TYPES']},`.includes(`,${d.code},`)"
                               defaultFirst></zselect>
                    </div>
                  </div>
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',idNumber,')"
                      class="form-group"
                  >
                    <label>{{ $t("证书号码") }}</label>
                    <zfield
                        v-model="registerForm.idNumber"
                        :placeholder="$t('证书号码')"
                        class="form-control mb-3"
                        name="idNumber"
                        required
                        type="text"
                    />
                  </div>
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',imgIdFront,')"
                      class="form-group"
                  >
                    <label>{{ $t("证书正面") }} </label>
                    <zfield
                        v-model="registerForm.imgIdFront"
                        required
                        type="image"
                        width="200px"
                    ></zfield>
                    <!--                    <div-->
                    <!--                      class="input-group"-->
                    <!--                      data-toggle="aizuploader"-->
                    <!--                      data-type="image"-->
                    <!--                    >-->
                    <!--                      <div class="input-group-prepend">-->
                    <!--                        <div-->
                    <!--                          class="input-group-text bg-soft-secondary font-weight-medium"-->
                    <!--                        >-->
                    <!--                          浏览-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                      <div class="form-control file-amount">选择文件</div>-->
                    <!--                      <zfield
                                          required-->
                    <!--                        type="hidden"-->
                    <!--                        name="identity_card_front"-->
                    <!--                        value=""-->
                    <!--                        class="selected-files"-->
                    <!--                      />-->
                    <!--                    </div>-->
                    <div class="file-preview box sm"></div>
                  </div>

                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',imgIdBack,')"
                      class="form-group"
                  >
                    <label>{{ $t("证书反面") }} </label>
                    <zfield
                        v-model="registerForm.imgIdBack"
                        required
                        type="image"
                        width="200px"
                    ></zfield>
                  </div>

                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',imgBusinessLicense,')"
                      class="form-group"
                  >
                    <label>{{ $t("营业执照") }} </label>
                    <zfield
                        v-model="registerForm.imgBusinessLicense"
                        required
                        type="image"
                        width="200px"
                    ></zfield>
                  </div>
                  <div class="form-group"
                       v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',imgHead,')"
                  >
                    <label>{{ $t("商店LOGO") }} </label>
                    <zfield
                        v-model="registerForm.imgHead"
                        required
                        type="image"
                        width="200px"
                    ></zfield>
                  </div>
                  <!--                  d-flex mt-4 justify-around-->
                  <div class="form-group"
                       v-if="`,${paramMapAll['REGISTER_PROPS_SELLER']},`.includes(',register_and_agree_to_the_terms,')"
                       style="display: flex"
                  >
                    <label class="aiz-checkbox" style="display: flex;">
                      <input
                           v-model="registerForm.checked"
                          name="checkbox_example_1"
                          required=""
                          type="checkbox"
                           @change="(event)=>{if(event.target.checked) { $refs.term.showInner=true; registerForm.checked2=event.target.checked }}"
                      />
                      <span class="opacity-60">
                             <zposterdialog-vant
                                 v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',register_and_agree_to_the_terms,')"
                                 :show="false" ref="term" class="full-width"
                                 poster-code="register_and_agree_to_the_terms_seller"
                                 @posterConfig="(posterConfig)=>{poster=posterConfig;showChecked=true}">
                                                    <template #default="{datas}">
                                                      <div v-if="datas && datas.subtitle">
                                                        {{ datas.subtitle.split('{title}')[0] }}
                                                        <span class="text-secondary ft-14"
                                                              @click="$refs.term.showInner=true">{{ datas.title }}</span>
                                                        {{ datas.subtitle.split('{title}')[1] }}
                                                      </div>
                                                    </template>
                                                  </zposterdialog-vant>
                           </span>
                      <span class="aiz-square-check"></span>
                    </label>
                    <!--                    <label>{{ $t("商店LOGO") }} </label>-->
                    <!--                    <van-checkbox class="mr-2 ml-1 border-radius" v-model="registerForm.checked" shape="square"></van-checkbox>-->

                  </div>
                </div>
              </div>

              <div class="text-right u-p-b-80">
                <van-button
                    v-loading="loading"
                    class="btn btn-primary fw-600"
                    native-type="submit"
                >
                  {{ $t("注册您的商店") }}
                </van-button>
              </div>
            </van-form>
          </div>
        </div>
      </div>
    </section>
    <div >
      <zposterdialog
          v-if="showPoster"
          class="u-p-lr-5"
          :show.sync="showPoster"
          poster-code="shopCreate"
          @posterNoConfig="()=>$router.push({'path': `/loginToUser?token=${encodeURIComponent(getLoginToken())}&isShopUser=true`})"
      />
    </div>

  </div>
</template>
<script>
import Zselect from "@/components/z/zselect.vue";
import store from "@/store";
import {getToken as getLoginToken} from "@/utils/auth";
import ValidCode from "@/views/validCode.vue";
import Zposterdialog from "@/components/z/zposterdialog.vue";

export default {
  async beforeRouteEnter(to, from, next) {
    await store.dispatch('common/dictListComputeIfAbsentEnum', 'EnumUserIdType')
    next((vm) => {
      // access to component public instance via `vm`
    })
  },
  components: {Zposterdialog,  ValidCode, Zselect},
  data() {
    return {
      disableCode: false,
      registerForm: {
        checked: false,
        codeNumber: null,
        isShopUser: true,
      },
      loading: false,
      showPoster: false,
      token: null
    };
  },
  created() {
    this.registerForm.codeNumber = this.$route.query.codeNumber;
    this.disableCode = !!this.$route.query.codeNumber;
  },
  methods: {
    getLoginToken() {
      return getLoginToken();
    },
    async commit() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      // userWithdraw["X-IDEMPOTENT-TOKEN"] = this.token;
      if (this.registerForm.rePassword && this.registerForm.rePassword !== this.registerForm.password) {
        this.loading = false;
        this.$toast.fail(this.$t("确认密码不一致"));
        return;
      }

      this.$post("/seller/oauth/register", this.registerForm)
          .then(async () => {
            this.loading = false;
            this.$store.dispatch("user/getUserInfo");
            this.$toast.success(this.$t("Commit_Success"));
            this.token = (await this.$store.dispatch("common/getToken")).data;
            this.showPoster = true
            // this.$router.back();
            // this.jump(`/loginToUser?token=${encodeURIComponent(getToken())}&isShopUser=true`)
          })
          .catch(() => {
            this.loading = false;
          })
          .finally(async () => {
          });
    }
  }
};
</script>
